import { render } from "./TabsControl.vue?vue&type=template&id=7297642c&scoped=true"
import script from "./TabsControl.vue?vue&type=script&lang=js"
export * from "./TabsControl.vue?vue&type=script&lang=js"

import "./TabsControl.vue?vue&type=style&index=0&id=7297642c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7297642c"]])

export default __exports__